import {
  AwxConnectedAccountStatus,
  AwxRfiStatus,
  OrganizationStateType,
} from "@common/utils/graphql";
import { FullPageLoader } from "@common/components/Loading/FullPageLoading";
import { ApplicationPending } from "./sheets/ApplicationPending";
import KYCOnboarding from "./sheets/KYCOnboarding";
import ConnectedAccountLink from "./sheets/PlaidConnectedAccountLink";
import RFIOnboarding from "./sheets/RFIOnboarding";
import ConnectedBankAccount from "./sheets/ConnectedBankAccount";
import { BankAccountOnboardingStateType } from "./BankAccountOnboardingStateType.types";
import { useEffect, useState } from "react";
import { SUCCESSFUL_LINKED_STATUSES } from "@common/state/organizationState";

export const BankAccountOnboardingState = ({
  organizationStateData,
}: {
  organizationStateData: OrganizationStateType | null;
}) => {
  const [bankAccountOnboardingState, setBankAccountOnboardingState] =
    useState<BankAccountOnboardingStateType>();

  useEffect(() => {
    const canStartKYC =
      organizationStateData?.connectedAccountStatus ===
        AwxConnectedAccountStatus.Created || organizationStateData === null;

    const needsAdditionalDetails =
      organizationStateData?.rfiStatus === AwxRfiStatus.ActionRequired;

    const kycSubmitted =
      organizationStateData?.connectedAccountStatus ===
      AwxConnectedAccountStatus.Submitted;

    const kycSuccess =
      organizationStateData?.connectedAccountStatus ===
      AwxConnectedAccountStatus.Active;

    const isAccountLinked = organizationStateData?.linkedAccountStatus
      ? SUCCESSFUL_LINKED_STATUSES.has(
          organizationStateData?.linkedAccountStatus,
        )
      : false;

    const showLinkAccount = !isAccountLinked && kycSuccess;

    if (needsAdditionalDetails) {
      setBankAccountOnboardingState("NEEDS_ADDITIONAL_DETAILS");
    } else if (showLinkAccount) {
      setBankAccountOnboardingState("LINK_ACCOUNT_READY");
    } else if (isAccountLinked) {
      setBankAccountOnboardingState("LINK_ACCOUNT_SUCCESS");
    } else if (canStartKYC) {
      setBankAccountOnboardingState("NOT_STARTED");
    } else if (kycSubmitted) {
      setBankAccountOnboardingState("KYC_SUBMITTED");
    }
  }, [
    organizationStateData?.connectedAccountStatus,
    organizationStateData?.linkedAccountStatus,
    organizationStateData?.rfiStatus,
    organizationStateData,
  ]);

  switch (bankAccountOnboardingState) {
    case "FAILURE":
      return <div>Failure Page or Message</div>;
    case "KYC_SUBMITTED":
      return <ApplicationPending />;
    case "NEEDS_ADDITIONAL_DETAILS":
      return <RFIOnboarding />;
    case "LINK_ACCOUNT_READY":
      return (
        <ConnectedAccountLink
          linkedAccountStatus={organizationStateData?.linkedAccountStatus}
        />
      );
    case "LINK_ACCOUNT_SUCCESS":
      return <ConnectedBankAccount />;
    case "NOT_STARTED":
      return <KYCOnboarding />;
    default:
      return <FullPageLoader />;
  }
};
